import {
  type BlobInputSimple,
  type BlobLike,
  IsWorker,
  UrlLoad,
} from "@pdfking/compatibility"
import { IsArray } from "@pdfking/tfunc"

declare const FileReaderSync: {
  new (): { readAsArrayBuffer(blob: Blob): ArrayBuffer }
}

const readSyncWorker = (blob: Blob): ArrayBuffer =>
  new FileReaderSync().readAsArrayBuffer(blob)

const readSyncXhr = (blob: Blob): ArrayBuffer => {
  const url = URL.createObjectURL(blob)
  try {
    const xhr = new XMLHttpRequest()
    xhr.open("GET", url, false)
    xhr.responseType = "arraybuffer"
    xhr.send()
    return xhr.response as ArrayBuffer
  } finally {
    URL.revokeObjectURL(url)
  }
}

class SyncBlob extends Blob implements BlobLike {
  arrayBufferSync(): ArrayBuffer {
    return IsWorker() ? readSyncWorker(this) : readSyncXhr(this)
  }

  createObjectURL(): Promise<string> {
    return Promise.resolve(URL.createObjectURL(this))
  }

  slice(start?: number, end?: number, contentType?: string): SyncBlob {
    return new SyncBlob([super.slice(start, end, contentType)], {
      type: this.type,
    })
  }
}

export const BlobCreate = (
  input: BlobInputSimple | BlobInputSimple[],
  type = "application/octet-stream"
): BlobLike =>
  new SyncBlob((IsArray(input) ? input : [input]) as BlobPart[], { type })

export const BlobFileCreate = (url: string, type?: string): Promise<BlobLike> =>
  UrlLoad(url).then(r =>
    r.blob().then(blob => BlobCreate(blob, type || blob.type))
  )
